import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { memo } from 'react';
import { uiImages } from '@/react/components/content/registry/data';
/**
 * Register the LinkOverlay component.
 */
const register = (): void => {
  Builder.registerComponent(memo(dynamic(async () => import('./index'))), {
    name: 'LinkOverlay',
    friendlyName: 'Link Overlay',
    description:
      'A component that serves as a link overlay. Renders a link that points to the specified URL.',
    inputs: [
      {
        name: 'target',
        friendlyName: 'Target URL',
        type: 'string',
        required: true,
        helperText: 'The URL that the overlay link points to.'
      },
      {
        name: 'ariaLabel',
        friendlyName: 'Aria Label',
        type: 'string',
        helperText: 'The aria-label attribute for accessibility purposes.'
      },
      {
        name: 'tabIndex',
        friendlyName: 'Tab Index',
        type: 'number',
        helperText: 'The tab index of the anchor link for keyboard navigation.',
        defaultValue: 1
      },
      {
        name: 'title',
        friendlyName: 'Hover Title',
        type: 'string',
        helperText: 'The title attribute to show on hover of the anchor link.',
        defaultValue: ''
      },
      {
        name: 'linkZIndex',
        friendlyName: 'Z-Index',
        type: 'number',
        helperText: 'The z-index of the link overlay.',
        defaultValue: 1
      }
    ],
    image: uiImages.sectionImage
  });
};
export default register;
